<template>
  <el-container>
    <el-header height="60px">
      <el-row>
        <!--        <el-col :span="8"><div class="header-grid-content">1</div></el-col>-->
        <el-col :xs="18" :sm="8" :md="8" :lg="8" :xl="8" style="float: left;">
          <div class="logo_img">
            <el-image :src="logo" style="width: 45px;
                   height: 34px;"></el-image>
          </div>
          <div class="titile_logo"><a href="/">MxDraw云图帮助</a></div>
        </el-col>
        <el-col :xs="6" :sm="16" :md="16" :lg="16" :xl="16" style="float: right;">
          <span class="hearder-tips logout" style="width: 50px" @click="logout">退出></span>
            <div  class="hidden-sm-and-down">
            <template  v-if="userInfo.usertype=='email'">
              <span class="hearder-tips" @click="drawer = true" >
                <i class="el-icon-user-solid"></i>
                {{userInfo.nickName}}
              </span>
            </template>
            <template v-else>
              <span class="hearder-tips">
                <i class="el-icon-user-solid"></i>
                {{userInfo.nickName}}
              </span>
            </template>
          <router-link to="mywork">
            <span class="hearder-tips">工单</span>
          </router-link>
          <router-link to="MxChm">
            <span class="hearder-tips">开发文档</span>
          </router-link>
          </div>
        </el-col>
      </el-row>
      <el-drawer
          title="我是标题"
          :visible.sync="drawer"
          :with-header="false"
          size="15%"
          >
          <span>用户名：{{userInfo.nickName}}</span><br>
          <span>购买产品：{{userInfo.goods}}</span><br>
          <span>购买时间：{{userInfo.startTime}}</span><br>
          <span>到期时间：{{userInfo.endTime}}</span>
        </el-drawer>
    </el-header>
    <el-container>
      <el-aside width="200px" class="hidden-sm-and-down">
        <el-row class="tac">
          <el-col :span="24">
            <el-menu
              default-active="2"
              router
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
            >
              <el-menu-item index="/mywork">
                <i class="el-icon-location" @click="thsi.$router.push('mywork')"></i>
                <span slot="title">我的工单</span>
              </el-menu-item>
              <a href="/workorder"><el-menu-item  class="is-active">
                <i class="el-icon-menu"></i>
                <span slot="title">创建工单</span>
              </el-menu-item></a>
                <template v-if="userInfo.usertype=='email'">
                <el-menu-item index="/downloadList">
                  <i class="el-icon-document"></i>
                  <span slot="title">控件下载</span>
                </el-menu-item>
              </template>
              <!-- <el-menu-item index="3" disabled>
                <i class="el-icon-document"></i>
                <span slot="title">实时工单</span>
              </el-menu-item>
              <el-menu-item index="4" disabled>
                <i class="el-icon-setting"></i>
                <span slot="title">VIP技术支持</span>
              </el-menu-item>-->
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-container>
        <el-header class="hearder-2">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/workorder">创建工单</a></el-breadcrumb-item>
          </el-breadcrumb>
        </el-header>
        <el-main style="overflow-y: auto">
          <el-card shadow="always">
            <el-steps :active="active">
              <el-step class="fz12" title="选择问题所属产品"></el-step>
              <el-step class="fz12" title="选择问题所属类型"></el-step>
              <el-step class="fz12" title="创建工单"></el-step>
            </el-steps>
          </el-card>

          <el-card shadow="always" style="margin-top: 50px;">
            <div
              v-if="show1"
              class="first_type"
              ref="first_type"
              style="display: flex;flex-wrap: wrap;"
            >
              <div
                class="grid-content bg-purple"
                v-for="(item,i) in workList"
                :key="i"
                @click="next(item.name,item.id)"
                @mouseover="mouseOver"
                @mouseleave="mouseLeave"
              >
                <img :src="item.icon" alt class="grid-content-img" />
                {{item.name}}
              </div>
            </div>

            <div
              v-if="show2"
              class="second_type"
              ref="second_type"
              style="display: flex;flex-wrap: wrap;"
            >
              <div
                class="grid-content bg-purple"
                v-for="(item,i) in typeList"
                :key="i"
                @click="next2(item.name,item.id)"
                @mouseover="mouseOver"
                @mouseleave="mouseLeave"
              >
              <img :src="item.icon" alt class="grid-content-img" />
              {{item.name}}
              </div>
            </div>

            <div class="tree_type" ref="tree_type" style="display: none">
              <div>
                <el-row>
                  <el-col :span="2" :offset="0">
                    <span>标题</span>
                  </el-col>
                  <el-col :span="22" :offset="0">
                    <el-input placeholder="请输入工单标题" v-model="title" clearable></el-input>
                  </el-col>
                </el-row>
              </div>

              <div style="margin: 40px 0;"></div>
              <div>
                <el-row>
                  <el-col :span="2" :offset="0">
                    <span>问题描述</span>
                  </el-col>
                  <el-col :span="22" :offset="0">
                    <el-input type="textarea" :rows="8" placeholder="请输入工单问题描述" v-model="account"></el-input>
                  </el-col>
                </el-row>
              </div>
              <div style="margin: 40px 0;"></div>

              <div>
                <el-row>
                  <el-col :span="12" :offset="2">
                    <!-- :before-upload="beforeUpload" -->

                    <el-upload
                      class="upload-demo"
                      action="/api/upload/"
                      
                      
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="3"
                      accept=".jpg,.png,.dwg,.dwf,.dxf,.txt" 
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      :on-success="uploadSuccess"
                    >
                      <el-button size="small" type="primary">添加附件</el-button>
                      <div slot="tip" class="el-upload__tip">注：单次上传文件不超过20M</div>
                    </el-upload>
                  </el-col>
                </el-row>
              </div>
              <div style="margin: 40px 0;"></div>
              <div>
                <el-row>
                  <el-col :span="2" :offset="0">
                    <span>邮箱</span>
                  </el-col>
                  <el-col :span="22" :offset="0">
                    <el-input placeholder="请填写邮箱" v-model="email" clearable></el-input>
                    <span style="float: left;font-size: 12px">该邮箱用于接收本次工单提醒</span>
                  </el-col>
                </el-row>
              </div>

              <div style="margin: 40px 0;"></div>
              <div>
                <el-row>
                  <el-col :span="2" :offset="0">
                    <span>手机</span>
                  </el-col>
                  <el-col :span="22" :offset="0">
                    <el-input placeholder="请填写手机号" v-model="mobile" clearable></el-input>
                    <span style="float: left;font-size: 12px">紧急情况时，MxDraw工程师会与您电话联系。</span>
                  </el-col>
                </el-row>
              </div>
              <div style="margin: 40px 0;"></div>
              <div>
                <el-row>
                  <el-col :span="1" :offset="2">
                    <el-button type="primary" @click="submit">提交工单</el-button>
                  </el-col>
                </el-row>
              </div>
            </div>

            <!--            <el-button>Dark</el-button><el-button>Dark</el-button><el-button>Dark</el-button><el-button>Dark</el-button><el-button>Dark</el-button>-->
          </el-card>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "work_order",
  data() {
    return {
      logo: require("../assets/img/logo2.png"),
      userInfo: {},
      show1: true,
      show2: false,
      active: 1,
      workList: [],
      typeList: [],
      product: "",
      type: "",

      title: "",
      account: "",
      email: "",
      mobile: "",
      drawer: false,
      upfile: [],
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
        // {
        //   name: "food2.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
      ],
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      //  alert(1)
      var that = this;
      //发送get请求
      this.$api.get("/workorder").then(
        function (res) {
          if (res.data.userInfo.userId == 0) {
            that.$router.push("/login");
          } else {
            that.userInfo = res.data.userInfo;
            that.workList = res.data.workList;
            that.typeList = res.data.typeList;
          }

          console.log(res);
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    next(name, id) {
      //选择工单所属业务
      //console.log(name, id);
      var that = this;
      that.$api.post("/getTypeList", { pid: id }).then(
        function (res) {
          if (res.data.code == "success") {
            if (res.data.data.length > 0) {
              that.show1 = false;
              that.show2 = true;
              that.active = 2;
              that.typeList = res.data.data;
              that.product = name;
            } else {
              that.$message({
                message: "选择的产品占无工单分类，请联系MxDraw客服反馈",
                type: "warning",
              });
            }
          } else {
            that.$message.error("服务器异常，请稍后重试！");
          }
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    next2(name, id) {
      //选择问题类型
      var that = this;
      that.type = name;
      that.active = 3;
      that.show1 = false;
      that.show2 = false;
      that.$refs.tree_type.style.display = "block";
    },
    submit() {
      //提交工单
      var that = this;
      var title = that.title;
      var account = that.account.replace(/\n/g,"<br/>");
      var file = JSON.stringify(that.fileList);
      var email = that.email;
      var mobile = that.mobile;
      var product = that.product;
      var type = that.type;
      if (
        !title ||
        !account ||
        !file ||
        !product ||
        !type
      ) {
        that.$message({
          message: "请先完善工单信息！",
          type: "warning",
        });
        return;
      }
      // var e_test = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      // var m_test = /^1[345789]\d{9}$/;
      // if (!e_test.test(email)) {
      //   that.$message({
      //     message: "请填写正确的邮箱",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (!m_test.test(mobile)) {
      //   that.$message({
      //     message: "请填写正确的手机号",
      //     type: "warning",
      //   });
      //   return;
      // }
      that.$api
        .post("/addwork", {
          title: title,
          account: account,
          file: file,
          product: product,
          type: type,
          mobile: mobile,
          email: email,
        })
        .then(
          function (res) {
            if (res.data.code == "success") {
              that.$router.push("/mywork");
            } else if (res.data.code == "login") {
              that.$router.push("/login");
            } else {
              that.$message({
                message: res.data.msg,
                type: "warning",
              });
              return;
            }
          },
          function () {
            that.$message.error("服务器异常，请稍后重试！");
          }
        );
    },
      logout() {
      var that = this;
      this.$api.post(`/mxdraw_logout`).then(
        function (res) {
          that.$router.push("/login");
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    mouseOver: function (e) {
      e.currentTarget.className = "grid-content bg-purple hover_border";
      //console.log("鼠标移入");

      //this.activeCss='hover_border'
    },
    mouseLeave: function (e) {
      // this.activeCss = '';
      e.currentTarget.className = "grid-content bg-purple";
      // console.log("鼠标移出");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      //alert("确定移除");
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制上传 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      var that = this;
      for (var i in that.fileList) {
          for (var k in that.fileList[i]) {
              if (that.fileList[i][k] == file.uid) {                                                 
              var index = that.fileList.indexOf(that.fileList[i]);
              if (index > -1) {
                 that.fileList.splice(index, 1);
              }	                       
              break;
            }
          }
        }
    },
    uploadSuccess(response, file, fileList){
            //console.log(response,file,fileList)
            var that = this;
            let files = {name:response.name,url:response.url};
            // let len = that.fileList.length;
            // that.fileList[len] = files;
      			that.fileList.push(files);
      		},
    // beforeUpload() {
    //   var that = this;
    //   const file = that.$refs.upload.uploadFiles[0];
    //   const formData = new FormData();
    //   const headerConfig = {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   };
    //   if (!file) {
    //     // 若未选择文件
    //     alert("请选择文件");
    //     return;
    //   }
    //   formData.append("file", file.raw);
    //   that.$api.post("/upload", formData, headerConfig).then(
    //     (res) => {
    //       console.log(res, "--------");
    //       that.upfile.push(file);
    //       console.log(that.upfile);
    //     },
    //     (res) => {
    //       that.$message.error("服务器异常，请稍后重试！");
    //     }
    //   );
    // },
  },
};
</script>


<style scoped>

a {
    text-decoration:none;
    cursor:pointer !important;
  }

.tree_type{
  margin-bottom: 10px;
  margin-top: 10px;
}

.upload-demo {
  text-align: left;
}

.hover_border {
  border: solid 1px #09f;
  color: #09f;
}

.grid-content {
  /*border-radius: 4px;*/
  /* display: flex; */
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 7rem;
  line-height: 100%;
  background-color: #f5f6fa;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 32%;
  margin-right: 10px;
}
.grid-content-img {
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-right: 10px;
}
.el-steps {
  text-align: left;
}
.hearder-tips {
  margin-left: 10px;
  float: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.el-breadcrumb {
  font-size: 17px;
  line-height: 60px;
}


.el-input-group {
  width: 15%;
  float: left;
  margin-bottom: 20px;
}
.el-header,
.el-footer {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
  border-bottom: solid 1px #e6e6e6;
}

.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 800px;
  height: 800px;
}

.el-main {
  background-color: #eef0f4;
  color: #333;
  text-align: center;
  /*line-height: 160px;*/
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.logo_img {
  width: 60px;
  height: 60px;
  line-height: 60px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logout {
  cursor: pointer;
}
.hearder-tips {
  color: #333;}

  .titile_logo{
      line-height: 60px;
      float: left;
      cursor: pointer;
  }

  .titile_logo a{
    color: #333;
    text-decoration:none;
     font-weight: 600;
    font-size: 1.3rem;
  }

  

@media screen and (max-width: 986px) {
  .grid-content {
    width: 48%;
  }
  .el-step__title /deep/ {
    font-size: 12px !important;
  }
}
@media screen and (max-width: 756px) {
  .grid-content {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder.vue